import { datadogLogs } from '@datadog/browser-logs';
import { env } from './env/constants';
import { getMode } from './env/feature-flag';
const isDatadogEnabled = () => !!env.VITE_DATADOG_ENABLED;
const getDatadogToken = () => env.VITE_DATADOG_CLIENT_TOKEN ?? '';
export const initializeLogger = () => {
  if (isDatadogEnabled()) {
    const mode = getMode();
    datadogLogs.init({
      clientToken: getDatadogToken(),
      site: 'ap1.datadoghq.com',
      service: 'dresscode-frontend',
      env: mode,
      // see vite.config.ts
      version: import.meta.env.PACKAGE_VERSION,
      forwardErrorsToLogs: true,
      // console logは料金に跳ねそうなので送らない
      forwardConsoleLogs: ['error'],
      sessionSampleRate: 100
    });
  }
};
export const injectLogContext = (context: {
  dressCodeUserId: string;
  tenantId: string;
  organizationId: string;
}) => {
  if (isDatadogEnabled()) {
    datadogLogs.setUser({
      id: context.dressCodeUserId,
      tenantId: context.tenantId,
      organizationId: context.organizationId
    });
  }
};

/**
 * フロントエンドのログ基盤がDatadogから例えばSentryになったときに影響範囲を狭めるためのラッパー
 * @return
 */
export const getLogger = () => {
  return {
    // biome-ignore lint/suspicious/noExplicitAny: <explanation>
    info: (message: string, context?: any) => datadogLogs.logger.info(message, context),
    // biome-ignore lint/suspicious/noExplicitAny: <explanation>
    warn: (message: string, context?: any) => datadogLogs.logger.warn(message, context),
    // biome-ignore lint/suspicious/noExplicitAny: <explanation>
    error: (message: string, context?: any, error?: Error) => datadogLogs.logger.error(message, context, error)
  };
};